var _style, _path, _circle, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBrokenImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_broken_image_svg__\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon_broken_image_svg__st1{fill:#333}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "icon_broken_image_svg__st1",
    cx: 20,
    cy: 9.5,
    r: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon_broken_image_svg__st1",
    d: "M23 19v-3h3c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1v22c0 .6.4 1 1 1h11c.6 0 1-.4 1-1v-2h3c.6 0 1-.4 1-1v-3h3c.6 0 1-.4 1-1zM4 25v-7.6l5.1-5.1 5.1 4.3L6.6 25H4zm17-7h-3c-.6 0-1 .4-1 1v3h-3c-.6 0-1 .4-1 1v2H9.3l8.8-9.7 2.9 2.2v.5zm0-3l-2.4-1.8c-.4-.3-1-.3-1.3.1l-1.7 1.9-5.9-5c-.2-.1-.5-.2-.7-.2-.3 0-.5.1-.7.3L4 14.6V5h21v9h-3c-.6 0-1 .4-1 1zM29 19h-4c-.6 0-1 .4-1 1v3h-3c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-8c0-.6-.4-1-1-1zm-1 8h-6v-2h3c.6 0 1-.4 1-1v-3h2v6z"
  })));
}

export default SvgIconBrokenImage;